export default __webpack_public_path__ + "static/media/Image2.3834fd9c.png";